import { createFileRoute } from '@tanstack/react-router';

import { AttributeFormScreen } from '@/features/catalog/AttributeForm';

/** Правка атрибута вместе с его привязкой к категориям. */
export const Route = createFileRoute('/_app/catalog_/attributes_/$attributeId')({
  component: EditAttributeRoute,
});

function EditAttributeRoute() {
  const { attributeId } = Route.useParams();
  // Ключ по идентификатору: форма берёт начальные значения при монтировании, и переход
  // с одного атрибута на другой без пересборки оставил бы поля от прежнего.
  return <AttributeFormScreen key={attributeId} attributeId={attributeId} />;
}
